(() => {
  const storeUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url.pathname + url.search + url.hash : null;
    } catch { return null; }
  };
  const initializeFit = (root) => {
    if (root.dataset.vxReady) return;
    root.dataset.vxReady = 'true';
    const params = new URLSearchParams(window.location.search);
    const tent = root.querySelector('#VXFit-tent');
    const size = root.querySelector('#VXFit-size');
    const match = Array.from(tent?.options || []).find((option) => option.dataset.modelId === params.get('tent'));
    if (match) {
      tent.value = match.value;
      if (size && params.has('size')) size.value = params.get('size').replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 120);
    }
  };
  const initializeCompare = (root) => {
    if (root.dataset.vxReady) return;
    let records;
    let labels;
    try {
      records = JSON.parse(root.querySelector('[data-vx-tent-data]').textContent);
      labels = JSON.parse(root.querySelector('[data-vx-labels]').textContent);
    } catch { return; }
    if (!Array.isArray(records) || !records.length) return;
    root.dataset.vxReady = 'true';
    const byKey = new Map(records.map((record) => [record.key, record]));
    const selects = Array.from(root.querySelectorAll('[data-vx-slot]'));
    const table = root.querySelector('.vx-tent-compare-table');
    const live = root.querySelector('[data-vx-live]');
    selects.forEach((select, index) => {
      if (!byKey.has(select.value) && !(index === 2 && !select.value)) {
        const candidate = records.find((record) => !selects.slice(0, index).some((previous) => previous.value === record.key));
        select.value = candidate?.key || '';
      }
    });
    const requestedModel = new URLSearchParams(window.location.search).get('tent');
    const requested = records.find((record) => record.model === requestedModel);
    if (requested && selects[0].value !== requested.key) {
      const oldFirst = selects[0].value;
      const other = selects.slice(1).find((select) => select.value === requested.key);
      if (other) other.value = oldFirst;
      selects[0].value = requested.key;
    }
    const createLink = (label, value, className) => {
      const href = storeUrl(value);
      if (!href) return null;
      const link = document.createElement('a');
      link.href = href;
      link.className = className;
      link.textContent = label;
      return link;
    };
    const render = (announce) => {
      const selected = selects.map((select) => select.value).filter(Boolean);
      table.style.setProperty('--vx-min-width', `${155 + selected.length * 230}px`);
      selects.forEach((select, index) => {
        Array.from(select.options).forEach((option) => {
          option.disabled = Boolean(option.value) && (!byKey.has(option.value) || selects.some((other, otherIndex) => otherIndex !== index && other.value === option.value));
        });
        const item = byKey.get(select.value);
        root.querySelectorAll(`[data-vx-cell="${index}"]`).forEach((cell) => {
          cell.hidden = !item;
          if (!item) return;
          if (cell.dataset.vxKey === item.key) return;
          cell.dataset.vxKey = item.key;
          const field = cell.dataset.vxField;
          if (field === 'header') {
            const name = document.createElement('span');
            name.className = 'vx-tent-model-name';
            name.textContent = `${item.name} — ${item.size}`;
            const price = document.createElement('span');
            price.className = 'vx-tent-model-price';
            price.textContent = item.price;
            cell.replaceChildren(name, price);
            if (!item.available) {
              const note = document.createElement('span');
              note.className = 'vx-tent-unavailable';
              note.textContent = labels.unavailable;
              cell.append(note);
            }
            if (item.image) {
              const image = document.createElement('img');
              image.src = item.image;
              image.alt = item.name;
              image.width = 240;
              image.height = 160;
              image.className = 'vx-tent-compare-image';
              image.loading = 'eager';
              cell.append(image);
            }
          } else if (field === 'actions') {
            const actions = document.createElement('div');
            actions.className = 'vx-tent-cell-actions';
            const view = createLink(labels.view, item.url, 'vx-tent-button');
            const fit = createLink(labels.fit, item.fitUrl, 'vx-tent-link');
            if (view) actions.append(view);
            if (fit) actions.append(fit);
            cell.replaceChildren(actions);
          } else {
            cell.textContent = item[field] || '';
          }
        });
      });
      if (announce && live) live.textContent = labels.updated;
    };
    selects.forEach((select) => select.addEventListener('change', () => render(true)));
    render(false);
  };
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-vx-fit]').forEach(initializeFit);
    scope.querySelectorAll('[data-vx-compare]').forEach(initializeCompare);
  };
  initialize();
  if (!window.vxTentGuideSectionListener) {
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    window.vxTentGuideSectionListener = true;
  }
})();
